import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Inner_Transfered_Card.css";

function Inner_Transfered_Card({
  item,
  icons,
  // mainImage,
  // changeMainImage,
  // index,
  // hideImages = false,
}) {
  const [activeMeal, setActiveMeal] = useState("breakfast");

  return (
    <div className="itinerary_card Inner_Summary_Card">
      <div className="day_card">
        {/* Transfer Section */}
        <div className="section_box">
          <div className="section_title">
            <img src={icons?.car} className="icon_img" alt="" />
            {item?.transferType}
          </div>

          <div className="transfer_mode">{item?.transferMode}</div>

          <div className="route_section">
            <div className="route_box">
              <p className="route_label">From</p>
              <div className="route_place">
                <img
                  src="/assets/images/cruise/itenarary/flight.png"
                  className="route_icon"
                  alt=""
                />
                {item?.ship_from}
              </div>
            </div>

            <div className="route_middle">
              <div className="route_line"></div>
            </div>

            <div className="route_box">
              <p className="route_label">To</p>
              <div className="route_place">
                <img
                  src="/assets/images/cruise/itenarary/hotel.png"
                  className="route_icon"
                  alt=""
                />
                {item?.to}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inner_Transfered_Card;
